<template>
  <div class="ibox">
      <div class="ib-sub-content">
          <!-- ユーザー検索ボックス-チェックボックス型 -->
        <div class="tabs-container">
            <div class="ibox-title search-box">
              <div class="row">
                  <div class="col-sm-12">
                      <div class="input-group">
                          <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserNameOrGroupNameOrOrganizationNameStr')">
                      </div>
                  </div>
              </div>
            </div>
            <div class="ib-sub-content">
                <b-tabs>
                  <b-tab :title="$t('userBtnTile')" class="tab-pane search-resultview">
                    <ul v-if="searchText == ''">
                      <li><label>{{$t('checkUserStrType')}}</label></li>
                      <li v-if="getVisitedUsers.length === 0" class="result-item"><label>{{$t('notFoundUserStr')}}</label></li>
                      <li v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo && user.userId !== uid" class="result-item"><label>
                        <input type="checkbox" v-model="checkUsers" v-bind:value="user.userId" class="checkbox public-check">
                        <span class="search-userimg">
                          <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                        </span>
                        <div class="search-userinfo">
                          <span class="search-username">{{ user.userInfo.userName }}</span>
                          <span class="search-userdept">{{ user.userInfo.dept }}</span>
                        </div>
                        <span class="check-mark"></span>
                      </label></li>
                    </ul>
                    <ul v-else>
                      <li v-if="Object.keys(this.getUsersBySearchText).length === 0" class="result-item"><label>{{$t('notFoundUserStr')}}</label></li>
                      <li v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo && key !== uid" class="result-item"><label>
                        <input type="checkbox" v-model="checkUsers" v-bind:value="key" class="checkbox public-check">
                        <span class="search-userimg">
                          <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                        </span>
                        <div class="search-userinfo">
                          <span class="search-username">{{ user.userInfo.userName }}</span>
                          <span class="search-userdept">{{ user.userInfo.dept }}</span>
                        </div>
                        <span class="check-mark"></span>
                      </label></li>
                    </ul>
                  </b-tab>
                    <b-tab :title="$t('peopleGroupTileType')" class="tab-pane search-resultview">
                        <ul v-if="searchText == ''">
                          <li v-if="Object.keys(this.getGroupsBySearchText).length === 0" class="result-item"><label>{{$t('notFoundGroupNameStr')}}</label></li>
                          <li v-for="(group, key) in getGroupsBySearchText" :key="group.id" v-if="Object.values(getGroupsBySearchText)[0] && group.groupName" class="result-item"><label>
                            <input type="checkbox" v-model="checkGroups" :value="key" name="public" class="checkbox public-check">
                            <div id="group1" class="ibox-child flex-box fl-between group-item">
                              <span v-if="group.ownerId == getUserId" class="crown-mark"><img :src="'static/img/assets/master.png'" alt=""></span>
                              <span class="group-name">{{group.groupName}}</span>
                              <span class="group-info">
                                  {{$t('memberStr')}}:
                                  <span class="menber-count">({{Object.keys(group.members).length}})</span>
                              </span>
                            </div>
                            <span class="check-mark"></span>
                          </label></li>
                        </ul>
                        <ul v-else>
                          <li v-if="Object.keys(this.getGroupsBySearchText).length === 0" class="result-item"><label>{{$t('notFoundGroupNameStr')}}</label></li>
                          <li v-for="(group, key) in getGroupsBySearchText" :key="group.id" v-if="Object.values(getGroupsBySearchText)[0] && group.groupName" class="result-item"><label>
                              <input type="checkbox" v-model="checkGroups" :value="key" name="public" class="checkbox public-check">
                              <div id="group1" class="ibox-child flex-box fl-between group-item">
                                  <span v-if="group.ownerId == getUserId" class="crown-mark"><img :src="'static/img/assets/master.png'" alt=""></span>
                                  <span class="group-name">{{group.groupName}}</span>
                                  <span class="group-info">
                                      {{$t('memberStr')}}<span class="menber-count">{{Object.keys(group.members).length}}</span>人
                                  </span>
                              </div>
                              <span class="check-mark"></span>
                          </label></li>
                        </ul>
                    </b-tab>
                    <b-tab :title="$t('organizationLabelStr')" class="tab-plane search-resultview">
                      <ul v-if="searchText == ''">
                        <li v-if="Object.keys(this.getOrganizationsBySearchText).length === 0" class="result-item"><label>{{$t('notFoundOrganizationNameStr')}}</label></li>
                        <organization-item :OrganizaitonPath="organizationOpens" @onClickOrganization="onClickOrg" :editAble="false" :checkedOrganizations="checkedOrgs" :bans="checkBans"/>
                      </ul>
                      <ul v-else>
                        <li v-if="Object.keys(organizationSearch.node).length === 0" class="result-item"><label>{{$t('notFoundOrganizationNameStr')}}</label></li>
                        <organization-item :OrganizaitonPath="organizationSearch" @onClickOrganization="onClickOrg" :editAble="false" :checkedOrganizations="checkedOrgs" :bans="checkBans"/>
                      </ul>
                    </b-tab>
              </b-tabs>
          </div>
        </div>
        <!-- /ユーザー検索ボックス-チェックボックス型 -->
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrganizationItem from '@/components/People/OrganizationItem'
export default {
  name: 'PublicSettingDetailView',
  props: {
    checkedGroups: {},
    checkedUsers: {},
    checkedOrgs: {},
    uid: ''
  },
  components: {
    OrganizationItem
  },
  data: function () {
    return {
      searchText: '',
      checkGroups: this.checkedGroups,
      checkUsers: this.checkedUsers,
      checkOrgs: this.checkedOrgs
    }
  },
  watch: {
    checkUsers: function () {
      this.$emit('updateUsers', this.checkUsers)
    },
    checkGroups: function () {
      this.$emit('updateGroups', this.checkGroups)
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUser'
    ]),
    ...mapGetters('groups/', [
      'getGroups',
      'getOnlyGroupsBySearchText'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds',
      'getUsersByText'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsByText',
      'getOpenOrganization',
      'getOrganizationExpansion',
      'getOrganizationRoots',
      'getOnlyOrganizationsByIds'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    checkBans () {
      let bans = []
      if (this.checkedOrgs.length > 0) {
        const orgRoots = this.getOrganizationRoots(this.checkedOrgs)
        orgRoots.forEach(function (value) {
          let exOrg = this.getOrganizationExpansion([value]) // Expansionはrootも入ってしまうため
          exOrg.splice(0, 1)
          bans = bans.concat(exOrg)
        }.bind(this))
      }
      return bans
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getGroupsBySearchText: function () {
      return this.getOnlyGroupsBySearchText(this.searchText)
    },
    organizationOpens: function () {
      let searchOpens = {roots: [], node: []}
      const groupIds = Object.keys(this.getGroups).filter(x => !this.getGroups[x].hasOwnProperty('isInactive'))
      let organizations = Object.keys(this.getOnlyOrganizationsByIds(groupIds).root).concat(this.checkedOrgs)
      searchOpens['roots'] = Object.keys(this.getOpenOrganization(organizations))
      for (let ser of Object.values(this.getOpenOrganization(organizations))) {
        searchOpens['node'] = searchOpens['node'].concat(ser['node'])
      }
      return searchOpens
    },
    organizationSearch: function () {
      let searchOpens = {roots: [], node: []}
      searchOpens['roots'] = Object.keys(this.getOpenOrganization(Object.keys(this.getOrganizationsBySearchText)))
      for (let ser of Object.values(this.getOpenOrganization(Object.keys(this.getOrganizationsBySearchText)))) {
        searchOpens['node'] = searchOpens['node'].concat(ser['node'])
      }
      return searchOpens
    },
    getOrganizationsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getGroups
      } else {
        return this.getOnlyOrganizationsByText(this.searchText)
      }
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        this.usersForRelation = this.getUsers
        return this.getUsers
      } else {
        this.usersForRelation = this.getUsersByText(this.searchText)
        return this.getUsersByText(this.searchText)
      }
    }
  },
  methods: {
    onClickOrg: function (organizationId) {
      const exOrg = this.getOrganizationExpansion([organizationId])
      let emitOrgs = []
      if (this.checkedOrgs.includes(organizationId)) {
        this.checkedOrgs.forEach(function (value) {
          if (!exOrg.includes(value)) {
            emitOrgs.push(value)
          }
        })
      } else {
        emitOrgs = this.checkedOrgs.concat(exOrg)
      }
      this.$emit('updateOrganization', emitOrgs)
    },
    resetCheckings () {
      this.checkUsers = []
      this.checkGroups = []
      this.checkOrgs = []
    }
  },
  filters: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DetailView/PublicSettingDetailView.vue